export default __webpack_public_path__ + "static/media/rgs_main_mobile_small@2x.4715cc5f.jpg";